import { DateTime } from 'luxon'

const startOfMonth = DateTime.now().startOf('month')
const startOfLastMonth = startOfMonth.minus({ months: 1 })

const endDate: string = startOfMonth.toISODate()
const startDate: string = startOfLastMonth.toISODate()

export type ReportKeyType =
['first_time_right_leaderboard' | 'template_rejections' | 'active_projects']

export type ReportDefaultStateType = {
  chart_data_key?: string,
  end_date?: string,
  start_date?: string,
}

type ReportModels = {
  [Key in ReportKeyType as string]: {
    defaultState: ReportDefaultStateType,
    requiredFields: {
      key: string,
      validation?: Function,
      invalidMessage?: string,
    }[],
  }
}

const reportModels: ReportModels = {
  first_time_right_leaderboard: {
    defaultState: {
      chart_data_key: '',
      end_date: endDate,
      start_date: startDate,
    },
    requiredFields: [
    ],
  },
  template_rejections: {
    defaultState: {
      end_date: endDate,
      start_date: startDate,
    },
    requiredFields: [
    ],
  },
  active_projects: {
    defaultState: {
    },
    requiredFields: [
    ],
  },
}

export default reportModels
